import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {factory} from '../shared/app-logging';
import {ErrorDataService} from './error-data.service';

const logger = factory.getLogger('RedirectService');

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private router: Router;


  constructor(private injector: Injector, private errorDataService: ErrorDataService) {
    this.router = this.injector.get(Router);
  }

  goToErrorPage(err: Error) {
    this.errorDataService.setError(err);
    this.router.navigateByUrl('error').then(value => {
      logger.debug(`Navigation to ERROR PAGE Fulfilled: ${value}`);
      if (value === false) { // When not TRUE and not NULL
        throw new Error(`An exception occurred while attempting to navigate to ERROR page.`);
      }
    }, reason => {
      throw new Error(`Navigation to ERROR PAGE Rejected: ${reason}`);
    });
  }

  goToLoginPage() {
    this.router.navigateByUrl('login').then(value => {
      logger.debug(`Navigation to LOGIN PAGE Fulfilled: ${value}`);
      if (value === false) { // When not TRUE and not NULL
        throw new Error(`An exception occurred while attempting to navigate to LOGIN page.`);
      }
    }, reason => {
      throw new Error(`Navigation to LOGIN PAGE Rejected: ${reason}`);
    });
  }

  goToLogoutPage() {
    this.router.navigateByUrl('logout').then(value => {
      logger.debug(`Navigation to LOGOUT PAGE Fulfilled: ${value}`);
      if (value === false) { // When not TRUE and not NULL
        throw new Error(`An exception occurred while attempting to navigate to LOGOUT page.`);
      }
    }, reason => {
      throw new Error(`Navigation to LOGOUT PAGE Rejected: ${reason}`);
    });
  }
}
